import { Box, Flex, Image } from '@chakra-ui/react';
import React, { FunctionComponent } from 'react';

interface ListItem {
  headline: string;
  body: string;
  image: string;
  category: string;
  url: string;
}

export const ListItem: FunctionComponent<ListItem> = (item) => {
  return (
    <>
      {item.headline && item.body && item.url && (
        <Flex
          as='a'
          href={item.url}
          w='100%'
          py='xs'
          borderBottom='1px solid'
          borderColor='mountain.20'
          justifyContent='space-between'
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <Flex basis='70%' flexDirection='column' maxW='780px'>
            <Box textTransform='capitalize'>{item.category}</Box>
            <Box as='h3' pt='xxs' pb='xs' textStyle={{ base: 'mobile.h4', md: 'desktop.h5' }}>
              {item.headline}
            </Box>
            <Box textStyle={{ md: 'desktop.body.l' }}>{item.body}</Box>
          </Flex>
          <Flex>
            <Image
              h={{ base: '250px', md: '170px' }}
              w={{ base: '100%', md: '300px' }}
              src={item.image}
              objectFit='cover'
            />
          </Flex>
        </Flex>
      )}
    </>
  );
};
